import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=f014ddcc&scoped=true&"
import script from "./BankTransfer.vue?vue&type=script&lang=ts&"
export * from "./BankTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f014ddcc",
  null
  
)

export default component.exports